import { BrowserInfo } from "@/utils/browser";
import Axios from "axios";

export interface ICashdroConfiguration {
	host:string;
	name:string;
	password:string;
	showScreen:boolean;
	screenUrl:string;
}

export interface CashDroResponse{
	code: number,
	data: string
}

class CashDroClass {

	saveConfiguration(config: ICashdroConfiguration | null){

		if(!config)
			return;

		localStorage.setItem("electron-cashdro-host", config.host);
		localStorage.setItem("electron-cashdro-name", config.name);
		localStorage.setItem("electron-cashdro-password", config.password);
		localStorage.setItem("electron-cashdro-show-screen", config.showScreen ? "1" : "0");
		localStorage.setItem("electron-cashdro-screen-url", config.screenUrl);
	}

	getConfiguration():ICashdroConfiguration{
		return new Object({
			host: localStorage.getItem(`electron-cashdro-host`) || "",
			name: localStorage.getItem(`electron-cashdro-name`) || "",
			password: localStorage.getItem(`electron-cashdro-password`) || "",
			showScreen: localStorage.getItem(`electron-cashdro-show-screen`) == "1",
			screenUrl: localStorage.getItem(`electron-cashdro-screen-url`) || ""
		}) as ICashdroConfiguration;
	}

	getBaseUrl(host:string):string{
		if(!host)
			return "";
		let base = /^https?:\/\//.test(host) ? host : `https://${host}`;
		return base.replace(/\/+$/, "");
	}

	getDefaultScreenUrl(host:string):string{
		if(!host)
			return "";
		return `${this.getBaseUrl(host)}/Cashdro3Web/index.html#/splash/true`;
	}

	getScreenUrl():string{
		let c = this.getConfiguration();
		if(!c.showScreen)
			return "";
		return c.screenUrl || this.getDefaultScreenUrl(c.host);
	}

	isDirect():boolean{
		return this.getConfiguration().showScreen;
	}

	private async direct(operation:string, params:any = {}, timeout = 10000):Promise<any>{
		let c = this.getConfiguration();
		let res = await Axios.get(`${this.getBaseUrl(c.host)}/Cashdro3WS/index3.php`, {
			timeout,
			params: {operation, name: c.name, password: c.password, ...params}
		});
		return res.data;
	}

	private async electron(path:string, params:any = {}, timeout?:number):Promise<CashDroResponse>{
		let c = this.getConfiguration() as any;
		let res = await Axios.get(`${BrowserInfo.getElectronUrl()}/payment/${path}`, {timeout, params: {...c, ...params}});
		return res.data as CashDroResponse;
	}

	async start(amount:number):Promise<CashDroResponse>{
		try {
			if(!this.isDirect())
				return await this.electron("start", {amount});
			let r = await this.direct("startOperation", {
				type: 4,
				posid: "winfakt",
				posuser: this.getConfiguration().name,
				parameters: JSON.stringify({amount: String(Math.round(amount * 100))})
			});
			if(r.code != 1)
				return {code: r.code, data: r.response?.errorMessage || ""};
			return {code: r.code, data: r.response?.operation?.operationId || ""};
		}catch (err) {
			return {
				code: 0,
				data: "string"
			} as CashDroResponse;
		}
	}

	async acknowledge(operation:string):Promise<CashDroResponse>{
		try {
			if(!this.isDirect())
				return await this.electron("acknowledge", {operation});
			let r = await this.direct("acknowledgeOperationId", {operationId: operation});
			return {code: r.code, data: r.response?.errorMessage || ""};
		}catch (err) {
			return {
				code: 0,
				data: "string"
			} as CashDroResponse;
		}
	}

	async ask(operation:string):Promise<CashDroResponse>{
		try {
			if(!this.isDirect())
				return await this.electron("ask", {operation});
			let r = await this.direct("askOperation", {operationId: operation});
			return {code: r.code, data: JSON.stringify(r.response?.operation || {})};
		}catch (err) {
			return {
				code: 0,
				data: "string"
			} as CashDroResponse;
		}
	}

	async cancel(operation:string):Promise<[]>{
		if(!this.isDirect()){
			await this.electron("cancel", {operation});
			return [];
		}
		await this.direct("finishOperation", {operationId: operation, type: 2});
		return [];
	}

	async test():Promise<CashDroResponse>{
		try {
			if(!this.isDirect())
				return await this.electron("test", {}, 3000);
			let r = await this.direct("login", {}, 3000);
			return {code: r.code, data: r.response?.errorMessage || ""};
		}catch (err) {
			return {
				code: 0,
				data: "string"
			} as CashDroResponse;
		}
	}

}

export const CashDro = new CashDroClass();
(window as any).cashdrow = CashDro;
